import React, { useState, useRef } from 'react';
import { Modal } from 'antd';
import BotSidebar from './BotSidebar';
import BotConversation from './BotConversation';

export default function BotModal({ open, onClose }) {
    // null = 新对话（未保存）; number = 已有会话 id
    const [currentId, setCurrentId] = useState(null);
    const sidebarRef = useRef(null);

    // BotConversation 新建/发送完后，通知 sidebar 刷新并把当前 id 同步过来
    const handleConversationChange = (id) => {
        setCurrentId(id);
        sidebarRef.current?.reload();
    };

    return (
        <Modal
            title="AI 助手"
            open={open}
            onCancel={onClose}
            footer={null}
            width="80%"
            destroyOnClose={true}
            centered={true}
            bodyStyle={{ padding: 0, height: '70vh', display: 'flex' }}
        >
            <div style={{ width: 240, flexShrink: 0 }}>
                <BotSidebar
                    ref={sidebarRef}
                    currentId={currentId}
                    onSelect={(id) => setCurrentId(id)}
                    onNew={() => setCurrentId(null)}
                />
            </div>
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0 }}>
                <BotConversation
                    key={currentId == null ? 'new' : currentId}
                    conversationId={currentId}
                    onConversationChange={handleConversationChange}
                />
            </div>
        </Modal>
    );
}
